
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

import { ProductItem } from '@/models/items/product-item-model';
import { GenericItem } from '@/models/items/generic-item-model';
import { ListModel } from '@/models/list-model';

import StaticItemMap from '@/components/StaticItemMap.vue';
import ItemStarWidget from '@/components/ItemStarWidget.vue';
import { ItemStarActions } from '@/actions/item-star-actions';
import { ListModelUtil } from '@/model-utils/list-model-util';

import { UserModule } from '@/store/modules/user';
import {
  AbstractItemModel,
  ItemType
} from '@/models/items/abstract-item-model';

@Component({ components: { StaticItemMap, ItemStarWidget } })
export default class OwnerItemCard extends Vue {
  @Prop(GenericItem) public item!: GenericItem;
  @Prop(ListModel) public list!: ListModel;

  timeAgo(item: AbstractItemModel) {
    return moment(item.timeAdded).fromNow();
  }

  get isProductItem() {
    return this.item.type === ItemType.Product.toString();
  }

  get isPlaceItem() {
    return this.item.type === ItemType.Place.toString();
  }

  get canEdit(): boolean {
    return ListModelUtil.canEditList(this.list, UserModule.currentUserId);
  }

  get brandMake() {
    return (this.item as ProductItem).brandMake;
  }

  get model() {
    return (this.item as ProductItem).model;
  }

  get tags() {
    return this.item.tags;
  }

  get title() {
    return this.item.title;
  }

  get subtitle() {
    return this.item.subtitle || this.item.asMedia.artist;
  }

  get description(): string {
    return this.item.description;
  }

  get url() {
    return this.item.url;
  }

  get urlDisplay() {
    const url = this.item.url || '';
    const maxLength = 50;
    if (url.length > maxLength) {
      return url.slice(0, maxLength) + '...';
    } else {
      return url;
    }
  }

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }
}
